import createIcon from '../../createIcon';

/**
 * @component @name PhonelinkOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgNi4wMDAzOVY0LjAwMDM5SDYuODJMOC44MiA2LjAwMDM5SDIyWk0xLjkyIDEuNjUwMzlMMC42NSAyLjkyMDM5TDIuNDcgNC43NDAzOUMyLjE4IDUuMDgwMzkgMiA1LjUyMDM5IDIgNi4wMDAzOVYxNy4wMDA0SDBWMjAuMDAwNEgxNy43M0wyMC4wOCAyMi4zNTA0TDIxLjM1IDIxLjA4MDRMMS45MiAxLjY1MDM5Wk00IDYuMjcwMzlMMTQuNzMgMTcuMDAwNEg0VjYuMjcwMzlaTTIzIDguMDAwMzlIMTdDMTYuNDUgOC4wMDAzOSAxNiA4LjQ1MDM5IDE2IDkuMDAwMzlWMTMuMTgwNEwxOCAxNS4xODA0VjEwLjAwMDRIMjJWMTcuMDAwNEgxOS44MkwyMi44MiAyMC4wMDA0SDIzQzIzLjU1IDIwLjAwMDQgMjQgMTkuNTUwNCAyNCAxOS4wMDA0VjkuMDAwMzlDMjQgOC40NTAzOSAyMy41NSA4LjAwMDM5IDIzIDguMDAwMzlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PhonelinkOff = createIcon('PhonelinkOff', [
  [
    'path',
    {
      d: 'M22 6.00039V4.00039H6.82L8.82 6.00039H22ZM1.92 1.65039L0.65 2.92039L2.47 4.74039C2.18 5.08039 2 5.52039 2 6.00039V17.0004H0V20.0004H17.73L20.08 22.3504L21.35 21.0804L1.92 1.65039ZM4 6.27039L14.73 17.0004H4V6.27039ZM23 8.00039H17C16.45 8.00039 16 8.45039 16 9.00039V13.1804L18 15.1804V10.0004H22V17.0004H19.82L22.82 20.0004H23C23.55 20.0004 24 19.5504 24 19.0004V9.00039C24 8.45039 23.55 8.00039 23 8.00039Z',
      key: 'bor6ei',
    },
  ],
]);

export default PhonelinkOff;
